import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M12 15.667c.427 0 .848-.098 1.23-.288l1.833-.917A2.74 2.74 0 0 0 16.583 12V9.28a2.74 2.74 0 0 0-1.52-2.459l-1.833-.917a2.76 2.76 0 0 0-2.46 0l-1.833.917a2.74 2.74 0 0 0-1.52 2.46V12a2.74 2.74 0 0 0 1.52 2.46l1.833.917c.382.19.803.29 1.23.29M9.25 12V9.28a1 1 0 0 1 .047-.275l1.998 1c.444.221.966.221 1.41 0l1.998-1q.045.135.047.275V12a.91.91 0 0 1-.507.82l-1.833.917a.93.93 0 0 1-.82 0l-1.834-.917A.91.91 0 0 1 9.25 12m9.166 9.167h-2.483l3.197-2.954c3.937-3.938 3.938-10.322 0-14.26C15.192.016 8.808.016 4.87 3.953c-3.938 3.938-3.938 10.322 0 14.26l3.197 2.954H5.583a.917.917 0 0 0 0 1.833h12.834a.917.917 0 1 0 0-1.833M6.166 5.25A8.25 8.25 0 1 1 17.86 16.89l-3.653 3.375a3.22 3.22 0 0 1-4.434-.016l-3.607-3.333a8.26 8.26 0 0 1 0-11.667"
    }, null, -1)
  ]))]))
}
export default { render: render }